import React, { useEffect } from "react";
import Frame from "components/shared/Frame";
import Button from "components/shared/Button";
import { useLocation, useNavigate } from "react-router-dom";
import trackEvent from "services/tracker.service";

const SuccessPage = ({
  value,
  button,
}: {
  value?: string;
  button?: string;
}) => {
  const navigate = useNavigate();

  const { state } = useLocation();
  const data = state as any;

  return (
    <Frame
      title="Your Account has been created successfully!"
      onBackButtonClick={() => navigate(-1)}
    >
      <h2 style={{ marginTop: 30 }}>Thank you!</h2>

      {button && (
        <Button
          onClick={() => {
            window.open("https://portal.heroicgameday.in/login", "_blank");
          }}
          value={button}
        />
      )}
    </Frame>
  );
};

export default SuccessPage;
